import { render } from "./App.vue?vue&type=template&id=200eb8c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=200eb8c6&lang=css"
script.render = render

export default script